import { render, staticRenderFns } from "./AffiliateTable.vue?vue&type=template&id=fe4b053e&"
import script from "./AffiliateTable.vue?vue&type=script&lang=ts&"
export * from "./AffiliateTable.vue?vue&type=script&lang=ts&"
import style0 from "./AffiliateTable.vue?vue&type=style&index=0&id=fe4b053e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports